//This had to be a normal component due to the need of generic props
import { Component, ReactNode } from 'react';
import { toast } from 'react-toastify';
import { defaultObject } from '../../../../../Helpers/typescriptHelper';
import { NetworkState } from '../../../../Model/Enum/NetworkState';
import { ResultWithValue } from '../../../Constants/Result/ResultWithValue';
import { SmallLoading } from '../../Loading/IntermediateLoading';
const hash = require('object-hash');

interface IProps<T> {
    [attribute: string]: any; // Additional props
    fetchData: () => Promise<ResultWithValue<T>>;
    renderFunction: (data: T, props: any) => ReactNode;
}

interface IState<T> {
    networkState: NetworkState;
    data: T;
    errorMessage?: string;
}

export class RenderFromServiceCall<T> extends Component<IProps<T>, IState<T>> {
    
    _isMounted: boolean = false;
    constructor(props: IProps<T>) {
        super(props);

        this.state = {
            networkState: NetworkState.Loading,
            data: defaultObject,

        };
    }
    
    async componentDidMount() {
        this._isMounted = true;
        try {
            var fetchResult: ResultWithValue<T> = await this.props.fetchData();
            if (this.state && this._isMounted)
                this.setState(() => {
                    return {
                        data: fetchResult.value ?? defaultObject,
                        networkState: fetchResult.isSuccess
                            ? NetworkState.Success
                            : NetworkState.Error,
                        errorMessage: fetchResult?.errorMessage ?? ''
                    }
                });
        }
        catch (exception) {
            console.warn('RenderFromServiceCall', exception);
            if (this._isMounted) {
                this.setState(() => {
                    return {
                        networkState: NetworkState.Error,

                        errorMessage: fetchResult?.errorMessage ?? ''

                    }
                });
            }
        }
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    render() {
        if (this.state.networkState === NetworkState.Loading) {
            return <SmallLoading />
        }
        if (this.state.networkState === NetworkState.Error) {
            // return a toast error message
            return toast.error(this.state.errorMessage ?? "Could not load data, please contact support")
        }
        return this.props.renderFunction(this.state.data, { ...this.props });
    }
}
